import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { AllUserRoles } from './models/enum/all-user-roles';
import { authGuard } from "./services/guards/auth.guard";

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            { path: '', redirectTo: 'contracts/search', pathMatch: 'full' },
            { path: 'contracts', loadChildren: () => import('./app/features/contracts/contracts.routes') },
            { path: 'processing', loadChildren: () => import('./app/features/processing/processing.routes') },
            { path: 'products', loadChildren: () => import('./app/features/products/products.routes') },
            { path: 'schedule', loadChildren: () => import('./app/features/schedule/schedule.routes') },
            { path: 'campaigns', loadChildren: () => import('./app/features/campaigns/campaigns.routes') },
            { path: 'installments', loadChildren: () => import('./app/features/installments/installments.routes') },
            { path: 'dashboard', loadComponent: () => import('./app/features/dashboard/dashboard').then((c) => c.Dashboard) },
            /*{
                path: 'processing',
                data: { roles: [AllUserRoles.HVS_USER] },
                canActivate: [authGuard],
                loadChildren: () => import('./app/features/processing/processing.routes')
            },*/
            {
                path: 'registry',
                data: { roles: [AllUserRoles.HVS_USER, AllUserRoles.HVS_SUPERVISOR] },
                canActivate: [authGuard],
                loadChildren: () => import('./app/features/registry/registry.routes')
            }
        ]
    },

    { path: 'notfound', loadComponent: () => import('@/layout/components/notfound').then((c) => c.Notfound) },
    { path: '**', redirectTo: '/notfound' }
];
